import './AppointmentActions.scss';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  loadAppointmentsRequests,
  rescheduleAppointment,
} from 'actions/appointments';
import { DateInput } from 'atoms/date-input';
import Dropdown from 'atoms/dropdown';
import ModalContent from 'atoms/modal-content';
import toast from 'atoms/toast';
import useQuery from 'hooks/useQuery';

import {
  availableHoursOptions,
  disableDropdown,
  isBusinessOpen,
  refreshAppointments,
  trackAppointmentAction,
} from './util';

export default function RescheduleModalContent({
  modalData,
  closeModal,
  isPetProfile,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = useQuery();
  const hours = useSelector((state) => state.provider.locations[0].hours);
  const [suggestions, setSuggestions] = useState({
    0: {},
    1: {},
    2: {},
    3: {},
    4: {},
  });

  const onConfirm = () => {
    const suggestedTimes = [];
    Object.entries(suggestions).forEach(([id, data]) => {
      if (data.date && data.timeStart) {
        suggestedTimes.push({
          date: data.date,
          times: [data.timeStart.valueFormatted],
        });
      }
      return null;
    });
    if (suggestedTimes.length > 0) {
      dispatch(
        rescheduleAppointment({
          appointmentId: modalData.appointment.uuid,
          body: { suggested: suggestedTimes },
        })
      ).then(({ success }) => {
        if (success) {
          trackAppointmentAction(modalData.appointment.status.value);
          if (isPetProfile) {
            dispatch(
              loadAppointmentsRequests(modalData.appointment.animal.uuid)
            );
          }
          refreshAppointments({ location, query, dispatch });
          toast({ text: 'Reschedule suggestions sent!' });
        }
      });
    }
  };

  return (
    <ModalContent
      title={modalData.title}
      subtitle={modalData.description}
      primaryButton="Confirm"
      secondaryButton="Cancel"
      primaryButtonAction={onConfirm}
      secondaryButtonAction={closeModal}
      onClose={closeModal}
    >
      {[...Array(5)].map((slot, i) => (
        <div className="flex-row mb-15" key={slot}>
          <DateInput
            className="mr-10 w-100"
            placeholder="Date"
            onChange={(date) => {
              setSuggestions({ ...suggestions, [i]: { timeStart: '', date } });
            }}
            value={suggestions[i].date || ''}
          />
          <Dropdown
            id={`time-${i}`}
            placeholder={isBusinessOpen(i, suggestions, hours)}
            className="w-100"
            items={availableHoursOptions(i, suggestions, hours)}
            generateKey
            isClearable
            disableDropdown={disableDropdown(i, suggestions, hours)}
            onClick={(timeStart) =>
              setSuggestions({
                ...suggestions,
                [i]: { ...suggestions[i], timeStart },
              })
            }
            value={suggestions[i].timeStart || ''}
          />
        </div>
      ))}
    </ModalContent>
  );
}
